import React from "react";
import PropTypes from "prop-types";

// One labelled fact inside a product detail card: icon, label, value. Two per row from small up,
// stacked below — the design's tile grid expressed proportionally rather than at its frame width.
// Whether a tile is worth rendering is the caller's call (the provider derives it per type).
function DetailTile({ icon, label, children }) {
  return (
    <div className="col-12 col-sm-6 mb-3">
      <div className="d-flex">
        <i className={`${icon} text-muted mt-1 me-2`} />
        <div className="flex-grow-1 overflow-hidden">
          <div className="text-muted small">{label}</div>
          <div className="fw-semibold text-break">{children}</div>
        </div>
      </div>
    </div>
  );
}

DetailTile.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default DetailTile;
